// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import TalkToExpertModal from "../TalkToExpertModal/TalkToExpertModal"; // import modal
// import { motion } from "framer-motion";
// export default function Header() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false); // modal state

//   const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
//   const closeSidebar = () => setSidebarOpen(false);

//   return (
//     <>
//       <header className="fixed top-0 left-0 right-0 z-50 bg-white ">
//         <nav className="px-4 lg:px-2 py-1 lg:py-1 flex items-center justify-between mx-auto max-w-screen-xl">
//           {/* <Link to="/" className="flex items-center">
//             <img
//               src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747318598/logoffbg-yi9BkSB3_mddicc.png"
//               className="mr-3 h-12"
//               alt="Logo"
//             />
//           </Link> */}
//           <motion.div
//             initial={{ x: -100, opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             transition={{ duration: 0.6, ease: "easeOut" }}
//           >
//             <Link
//               to="/"
//               className="flex items-center transition-transform duration-300 hover:scale-105"
//             >
//               <img
//                 src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747318598/logoffbg-yi9BkSB3_mddicc.png"
//                 className="mr-3 h-12"
//                 alt="Logo"
//               />
//             </Link>
//           </motion.div>
//           <div className="lg:flex items-center space-x-4 hidden">
//             <Link
//               to="/career"
//               className="relative inline-block text-blue-800 hover:text-[#ba195f] font-medium text-md px-4 py-0 font-Questrial group"
//             >
//               Career
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-[#ba195f] transition-all duration-300 group-hover:w-full origin-left"></span>
//             </Link>
//             <Link
//               to="/blog"
//               className="relative inline-block text-blue-800 hover:text-[#ba195f] font-medium text-md px-4 py-0 font-Questrial group"
//             >
//               Blog
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-[#ba195f] transition-all duration-300 group-hover:w-full origin-left"></span>
//             </Link>

//             {/* Let's Talk Button */}
//             <button
//               onClick={() => setModalOpen(true)}
//               className="text-white bg-indigo-700 hover:bg-[#ba195f] font-medium rounded-lg text-sm px-4 py-1.5 font-Questrial"
//             >
//               Let's Talk
//             </button>
//           </div>
//           <div className="lg:hidden">
//             <button
//               onClick={toggleSidebar}
//               className="text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-300 rounded-lg p-2"
//             >
//               <svg
//                 className="h-6 w-6"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 {sidebarOpen ? (
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 ) : (
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M4 6h16M4 12h16m-7 6h7"
//                   />
//                 )}
//               </svg>
//             </button>
//           </div>
//           <div
//             className={`lg:flex items-center space-x-4 fixed inset-y-0 right-0 bg-white z-50 w-64 px-4 py-6 transition-all duration-300 ${
//               sidebarOpen ? "translate-x-0" : "translate-x-full"
//             }`}
//           >
//             <button
//               onClick={closeSidebar}
//               aria-label="Close sidebar"
//               className="absolute top-3 right-3 text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-300 rounded-lg p-2"
//             >
//               <svg
//                 className="h-6 w-6"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M6 18L18 6M6 6l12 12"
//                 />
//               </svg>
//             </button>
//             <div className="flex flex-col space-y-2 lg:hidden">
//               <Link
//                 to="/career"
//                 className="text-blue-800 hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 py-2.5 focus:outline-none font-Questrial"
//               >
//                 Career
//               </Link>
//               <Link
//                 to="/blog"
//                 className="text-blue-800 hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 py-2.5 focus:outline-none font-Questrial"
//               >
//                 Blog
//               </Link>
//               <button
//                 onClick={() => {
//                   setModalOpen(true);
//                   closeSidebar();
//                 }}
//                 className="text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:ring-orange-300 font-medium rounded-lg text-sm px-4 py-2.5 focus:outline-none font-Questrial"
//               >
//                 Let's Talk
//               </button>
//             </div>
//           </div>
//         </nav>
//       </header>

//       {/* Modal */}
//       <TalkToExpertModal
//         isOpen={modalOpen}
//         onClose={() => setModalOpen(false)}
//       />
//     </>
//   );
// }

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import TalkToExpertModal from "../TalkToExpertModal/TalkToExpertModal";
import { motion } from "framer-motion";

export default function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  const navLinks = [
    { name: "Career", path: "/career" },
    { name: "Blog", path: "/blog" },
  ];

  const activeClass =
    "text-[#ba195f] font-semibold border-b-2 border-[#ba195f]";
  const inactiveClass =
    "text-blue-800 hover:text-[#ba195f] font-medium transition-colors duration-300";

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white">
        <nav className="px-4 lg:px-2 py-1 flex items-center justify-between mx-auto max-w-screen-xl">
          {/* Logo */}
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <NavLink
              to="/"
              className="flex items-center transition-transform duration-300 hover:scale-105 focus:outline-none "
              aria-label="Go to Home Page"
            >
              <img
                src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747318598/logoffbg-yi9BkSB3_mddicc.png"
                className="mr-3 h-12"
                alt="Navishaa Logo"
              />
            </NavLink>
          </motion.div>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center space-x-6">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  `relative px-3 py-1 text-md font-Questrial ${
                    isActive ? activeClass : inactiveClass
                  }`
                }
              >
                {link.name}
                <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-[#ba195f] transition-all duration-300 group-hover:w-full origin-left"></span>
              </NavLink>
            ))}

            {/* Let's Talk Button */}
            <button
              onClick={() => setModalOpen(true)}
              className="text-white bg-indigo-700 hover:bg-[#ba195f] focus:ring-2 focus:ring-indigo-500 font-medium rounded-lg text-sm px-4 py-1.5 font-Questrial transition-colors duration-300"
            >
              Let's Talk
            </button>
          </div>

          {/* Mobile Hamburger */}
          <div className="lg:hidden">
            <button
              onClick={toggleSidebar}
              aria-label={sidebarOpen ? "Close menu" : "Open menu"}
              className="text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-300 rounded-lg p-2"
            >
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {sidebarOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Sidebar */}
          <div
            className={`lg:flex items-center fixed inset-y-0 right-0 bg-white z-50 w-64 px-4 py-6 transition-transform duration-300 ${
              sidebarOpen ? "translate-x-0" : "translate-x-full"
            } shadow-lg`}
          >
            <button
              onClick={closeSidebar}
              aria-label="Close sidebar"
              className="absolute top-3 right-3 text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-300 rounded-lg p-2"
            >
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="flex flex-col space-y-4 mt-8">
              {navLinks.map((link) => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  onClick={closeSidebar}
                  className={({ isActive }) =>
                    `px-4 py-2 rounded-lg text-sm font-Questrial focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                      isActive ? activeClass : inactiveClass
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              ))}

              <button
                onClick={() => {
                  setModalOpen(true);
                  closeSidebar();
                }}
                className="text-white bg-indigo-700 hover:bg-[#ba195f] focus:ring-2 focus:ring-indigo-500 font-medium rounded-lg text-sm px-4 py-2.5 font-Questrial transition-colors duration-300"
              >
                Let's Talk
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* Modal */}
      <TalkToExpertModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}
